import React from 'react'

function UpdateProduct() {
  return (
    <div>UpdateProduct</div>
  )
}

export default UpdateProduct